import {
    CREATE_BRANCH,
    CREATE_BRANCH_FAIL,
    CREATE_BRANCH_SUCCESS,
    DELETE_BRANCH,
    DELETE_BRANCH_FAIL,
    DELETE_BRANCH_SUCCESS,
    GET_BRANCH_LISTING,
    GET_BRANCH_LISTING_FAIL,
    GET_BRANCH_LISTING_SUCCESS,
    RESET_BRANCH_ACTION_STATE,
    RESET_BRANCH_STATE,
    UPDATE_BRANCH,
    UPDATE_BRANCH_FAIL,
    UPDATE_BRANCH_SUCCESS
} from "./actionTypes";

export const getBranchListing = (data) => ({
    type: GET_BRANCH_LISTING,
    payload: data,
});

export const getBranchListingSuccess = data => ({
    type: GET_BRANCH_LISTING_SUCCESS,
    payload: data,
});

export const getBranchListingFail = error => ({
    type: GET_BRANCH_LISTING_FAIL,
    payload: error,
});

export const createBranch = (data) => ({
    type: CREATE_BRANCH,
    payload: data,
});

export const createBranchSuccess = data => ({
    type: CREATE_BRANCH_SUCCESS,
    payload: data,
});

export const createBranchFail = error => ({
    type: CREATE_BRANCH_FAIL,
    payload: error,
});

export const updateBranch = (data) => ({
    type: UPDATE_BRANCH,
    payload: data,
});

export const updateBranchSuccess = data => ({
    type: UPDATE_BRANCH_SUCCESS,
    payload: data,
});

export const updateBranchFail = error => ({
    type: UPDATE_BRANCH_FAIL,
    payload: error,
});

export const deleteBranch = (data) => ({
    type: DELETE_BRANCH,
    payload: data,
});

export const deleteBranchSuccess = data => ({
    type: DELETE_BRANCH_SUCCESS,
    payload: data,
});

export const deleteBranchFail = error => ({
    type: DELETE_BRANCH_FAIL,
    payload: error,
});

//reset
export const resetBranchActionState = () => {
    return {
        type: RESET_BRANCH_ACTION_STATE,
    }
}
export const resetBranchState = () => {
    return {
        type: RESET_BRANCH_STATE,
    }
}

